const v = "4.8.0";
const meta = {
  g: "LottieFiles AE ",
  a: "",
  k: "",
  d: "",
  tc: ""
};
const fr = 29.9700012207031;
const ip = 0;
const op = 41.0000016699642;
const w = 80;
const h = 83;
const nm = "button_circle";
const ddd = 0;
const assets = [];
const layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "button 윤곽선",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          40,
          40.5,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          24.25,
          24.25,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                1,
                1,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 0,
            s: [
              100,
              100,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 6,
            s: [
              80,
              80,
              100
            ]
          },
          {
            i: {
              x: [
                0.258,
                0.258,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 13,
            s: [
              115,
              115,
              100
            ]
          },
          {
            t: 20.0000008146167,
            s: [
              100,
              100,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0.39,
                    -0.391
                  ],
                  [
                    -0.391,
                    -0.39
                  ]
                ],
                o: [
                  [
                    -0.391,
                    -0.391
                  ],
                  [
                    -0.391,
                    0.391
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -2.793,
                    -7.707
                  ],
                  [
                    -4.207,
                    -7.707
                  ],
                  [
                    -4.207,
                    -6.293
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ind: 1,
            ty: "sh",
            ix: 2,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.391,
                    0.391
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.391,
                    -0.39
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    0
                  ],
                  [
                    4.207,
                    0.707
                  ],
                  [
                    4.207,
                    -0.707
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 2",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ind: 2,
            ty: "sh",
            ix: 3,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.391,
                    -0.39
                  ],
                  [
                    -0.391,
                    0.391
                  ]
                ],
                o: [
                  [
                    -0.391,
                    0.391
                  ],
                  [
                    0.39,
                    0.391
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -4.207,
                    6.293
                  ],
                  [
                    -4.207,
                    7.707
                  ],
                  [
                    -2.793,
                    7.707
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 3",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ind: 3,
            ty: "sh",
            ix: 4,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -4.207,
                    -6.293
                  ],
                  [
                    2.793,
                    0.707
                  ],
                  [
                    4.207,
                    -0.707
                  ],
                  [
                    -2.793,
                    -7.707
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 4",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ind: 4,
            ty: "sh",
            ix: 5,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.793,
                    -0.707
                  ],
                  [
                    -4.207,
                    6.293
                  ],
                  [
                    -2.793,
                    7.707
                  ],
                  [
                    4.207,
                    0.707
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 5",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 1,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                24.75,
                24.25
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 9,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    13.255
                  ],
                  [
                    -13.255,
                    0
                  ],
                  [
                    0,
                    -13.255
                  ],
                  [
                    13.255,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    -13.255
                  ],
                  [
                    13.255,
                    0
                  ],
                  [
                    0,
                    13.255
                  ],
                  [
                    -13.255,
                    0
                  ]
                ],
                v: [
                  [
                    -24,
                    0
                  ],
                  [
                    0,
                    -24
                  ],
                  [
                    24,
                    0
                  ],
                  [
                    0,
                    24
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.333
                    ],
                    y: [
                      0
                    ]
                  },
                  t: 5,
                  s: [
                    1,
                    0.682352941176,
                    0.011764706817,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.258
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.333
                    ],
                    y: [
                      0
                    ]
                  },
                  t: 10,
                  s: [
                    1,
                    0.870168089867,
                    0.596078395844,
                    1
                  ]
                },
                {
                  t: 17.0000006924242,
                  s: [
                    1,
                    0.682352941176,
                    0.011764706817,
                    1
                  ]
                }
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                24.25,
                24.25
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 4,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 41.0000016699642,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "모양 레이어 1",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 0,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 13,
            s: [
              50
            ]
          },
          {
            t: 30.0000012219251,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          40,
          41.5,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0,
                0,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 0,
            s: [
              78,
              78,
              100
            ]
          },
          {
            t: 30.0000012219251,
            s: [
              130,
              130,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            d: 1,
            ty: "el",
            s: {
              a: 0,
              k: [
                48,
                50
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 3
            },
            nm: "타원 패스 1",
            mn: "ADBE Vector Shape - Ellipse",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                0.682353001015,
                0.011765000399,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 7,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                0.682352941176,
                0.011764706817,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "타원 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 30.0000012219251,
    st: 5.00000020365417,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: "shadow 윤곽선",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 10,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          24.25,
          26.25,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          24,
          24,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    13.255
                  ],
                  [
                    -13.255,
                    0
                  ],
                  [
                    0,
                    -13.255
                  ],
                  [
                    13.255,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    -13.255
                  ],
                  [
                    13.255,
                    0
                  ],
                  [
                    0,
                    13.255
                  ],
                  [
                    -13.255,
                    0
                  ]
                ],
                v: [
                  [
                    -24,
                    0
                  ],
                  [
                    0,
                    -24
                  ],
                  [
                    24,
                    0
                  ],
                  [
                    0,
                    24
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                24,
                24
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 4,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 41.0000016699642,
    st: 0,
    bm: 0
  }
];
const markers = [];
const buttonAnimation = {
  v,
  meta,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
export {
  assets,
  ddd,
  buttonAnimation as default,
  fr,
  h,
  ip,
  layers,
  markers,
  meta,
  nm,
  op,
  v,
  w
};
//# sourceMappingURL=toon_button_reaction.json.js.map
